import { SWRConfiguration } from 'swr'

export const swrConfig: SWRConfiguration = {
  dedupingInterval: 0,
  refreshInterval: 0,
  revalidateIfStale: false,
  revalidateOnFocus: false,
}
export const withNoRetryOnStatus = (...codes: number[]): SWRConfiguration => ({
  ...swrConfig,
  shouldRetryOnError: (error) => !codes.includes(error?.statusCode),
})
